/**
 * Checks if received claim numbers have at least one group of numbers
 *
 * @param {object} claimNumbers
 * @returns {boolean}
 */
export const hasClaimNumbers = claimNumbers => {
  if (!claimNumbers) {
    return false
  }
  if (
    claimNumbers.hasOwnProperty('insuranceCompanies') &&
    claimNumbers.insuranceCompanies.length > 0
  ) {
    return true
  }
  if (claimNumbers.hasOwnProperty('brokerages') && claimNumbers.brokerages.length > 0) {
    return true
  }
  return false
}
